import axiosInstance from 'api/axiosInstance';
import { URL_CANTRACK_READ_CUSTOMERS } from 'constants/urls';

interface CustomerFilters {
  SearchKeyword?: string;
  Page?: number;
  Take?: number;
  SortBy?: string;
  SortDirection?: string;
}

const getCustomers = async (filters: CustomerFilters = {}) => {
  const payload = {
    SearchKeyword: filters.SearchKeyword || '',
    Page: filters.Page || 1,
    Take: filters.Take || 1000,
    ...filters,
  };

  try {
    const { data } = await axiosInstance.get(
      `${URL_CANTRACK_READ_CUSTOMERS}?payload=${JSON.stringify(payload)}`,
    );
    return data;
  } catch (error) {
    console.error('[getCustomers] Failed:', error);
    throw error;
  }
};

export default getCustomers;
